import React from "react";
import { AddToolTip } from "../../../../components";
export const UploadedDocuments = (props) => {
  return (
    <div className="transaction-history-withdrawal">
      <div className="transaction-history-withdrawal-header">
        Uploaded Documents
      </div>
      <div className="distribution-card p-4" style={{ margin: "1rem 1rem" }}>
        <div className="d-flex flex-row justify-content-between ml-2">
          <div
            className="d-flex justify-content-start"
            style={{ height: "20px", maxWidth: "375px" }}
          >
            <i class="fas file-pdf-o distrbution-word"></i> &nbsp;
            {<AddToolTip name="doc 1" />}
          </div>

          <div
            className="d-flex justify-content-start"
            style={{ height: "20px", maxWidth: "375px" }}
          >
            <i class="fas file-pdf-o distrbution-word"></i> &nbsp;
            <AddToolTip name="doc 2" />
          </div>
          <div className="col-1"></div>
        </div>
      </div>
    </div>
  );
};
